/** Gelişim ekranından skill puanı ile yükseltilebilecek son seviye (17 = m1) */
export const SKILL_LEVEL_DEV_MAX = 17;
export const SKILL_LEVEL_MAX = 37;

/** 17+ usta seviyeleri (m1, m2, ...) gelişim ekranından yükseltilemez */
export const canUpgradeSkillInDevelopment = (level) => Number(level) < 17;

/** 17-36 arası skill'ler taşlı sistemle yükseltilebilir; 37 = p son seviyedir. */
export const canPromoteSkill = (level) => {
  const n = Number(level);
  return Number.isFinite(n) && n >= SKILL_LEVEL_DEV_MAX && n < SKILL_LEVEL_MAX;
};

/**
 * Beceri seviyesini gösterim etiketine çevirir.
 * 1-16: sayı, 17-26: m1-m10, 27-36: g1-g10, 37: p
 */
export const formatSkillLevel = (level) => {
  const n = Number(level);
  if (!Number.isFinite(n) || n < 1) return String(level ?? '1');
  if (n <= 16) return String(n);
  if (n <= 26) return `m${n - 16}`;
  if (n <= 36) return `g${n - 26}`;
  return 'p';
};

/** Gelişim ekranı için "Lv. 16" veya "m1" formatı */
export const formatSkillLevelForDevelopment = (level) => {
  const n = Number(level);
  if (!Number.isFinite(n) || n < 1) return `Lv. ${level ?? 1}`;
  if (n <= 16) return `Lv. ${n}`;
  return formatSkillLevel(n);
};
